import React, {Component} from 'react';
import axios from "axios";
import {connect} from "react-redux";
import {Spinner} from "react-bootstrap";
import {FaDonate} from "react-icons/fa";
import Breadcrumb from "../../Layout/Breadcrumb";
import {Alert, Card, CardBody, CardHeader, Table} from 'reactstrap';
import {Link} from "react-router-dom";

class DetailPaymentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            user: {},
            error: false,
            messageError: '',
            payment: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getPaymentDetail(this.props.paymentId);
    }

    getPaymentDetail = (paymentId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/payment/getPaymentDetail/' + paymentId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        payment: ref.data.content,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    loadStatus = () => {
        if (this.state.payment.status === 'Active') {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else if (this.state.payment.status === 'Waiting') {
            return (
                <span className="text-info">Thanh toán chờ</span>
            )
        }
        else if (this.state.payment.status === 'Pending') {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if (this.state.payment.status === 'Cancel') {
            return (
                <span className="text-info">Hủy</span>
            )
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chi tiết thanh toán"} page={"Thanh toán"} icon={<FaDonate className="breadcrumb-icon"/>} />
                            <div className="row">
                                {
                                    this.state.error ? (
                                        <div className="col-md-12">
                                            <Alert color="danger">
                                                {this.state.messageError}
                                            </Alert>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="col-md-9" style={{ margin: 'auto'  }}>
                                                <Card className="card-info">
                                                    <CardHeader>
                                                        <h4 className="card-title">Thông tin thanh toán</h4>
                                                    </CardHeader>
                                                    <CardBody className="payment-detail-body">
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Khách hàng</div>
                                                            <div className="col-md-8">
                                                                <Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.state.payment.user_id}>{this.state.payment.text_user_name}</Link>
                                                            </div>
                                                        </div>
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Mã giao dịch</div>
                                                            <div className="col-md-8">
                                                                { this.state.payment.ma_gd }
                                                            </div>
                                                        </div>
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Ngày giao dịch</div>
                                                            <div className="col-md-8">
                                                                { this.state.payment.text_create_date }
                                                            </div>
                                                        </div>
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Số tiền</div>
                                                            <div className="col-md-8">
                                                                { this.state.payment.text_total } ₫
                                                            </div>
                                                        </div>
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Loại</div>
                                                            <div className="col-md-8">
                                                                { this.state.payment.type_payment }
                                                            </div>
                                                        </div>
                                                        <div className="row payment-detail">
                                                            <div className="col-md-4">Trạng thái</div>
                                                            <div className="col-md-8">
                                                                { this.loadStatus() }
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.payment.status === 'Active' || this.state.payment.status === 'Waiting' ? (
                                                                <div className="row payment-detail">
                                                                    <div className="col-md-4">Thời gian thanh toán</div>
                                                                    <div className="col-md-8">
                                                                        { this.state.payment.text_payment_date }
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </CardBody>
                                                </Card>
                                            </div>
                                            {
                                                this.state.payment.status === 'Active' ? (
                                                    <div className="col-md-9" style={{ margin: 'auto'  }}>
                                                        <Card className="card-success">
                                                            <CardHeader>
                                                                <h4 className="card-title">Thông tin dịch vụ</h4>
                                                            </CardHeader>
                                                            <CardBody className="table-responsive">
                                                                <Table className="table table-sm table-bordered table-hover rounded text-center">
                                                                    <thead className="primary">
                                                                    <tr>
                                                                        <th>Loại</th>
                                                                        <th>Sản phẩm</th>
                                                                        <th>Dịch vụ</th>
                                                                        <th>Thời gian thuê</th>
                                                                        <th>Ngày bắt đầu</th>
                                                                        <th>Ngày kết thúc</th>
                                                                        <th>Giá</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {
                                                                        this.state.payment.listService.map( (service, key) =>  (
                                                                            <tr key={key}>
                                                                                <td>{ service.text_type }</td>
                                                                                <td>{ service.product_name }</td>
                                                                                <td>
                                                                                    <Link to={service.link + service.id}>{ service.service_name }</Link>
                                                                                </td>
                                                                                <td>{ service.text_billing_cycle }</td>
                                                                                <td>{ service.text_create_date }</td>
                                                                                <td>{ service.text_next_due_date }</td>
                                                                                <td>{ service.text_amount }</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                    </tbody>
                                                                </Table>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </>
                                    )
                                }
                            </div>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerDetailPayment' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailPaymentComponent);